document.addEventListener('DOMContentLoaded', () => {
  function _doAdjustMinHeight(block) {
    const blockId = block.dataset.blockId
    const sectionId = block.dataset.sectionId
    const imgWrapper = block.querySelector(`.js-hiw-block-carousel-${blockId}`)
    const h = imgWrapper.getBoundingClientRect().height

    const minHeight = Number(getComputedStyle(document.querySelector(`.hiw-${sectionId}`)).getPropertyValue('--image-container-min-height').replace('px', '')) || 0
    if (h > minHeight) {
      document.querySelector(`.hiw-${sectionId}`).style.setProperty('--image-container-min-height', `${h}px`)
    }
  }

  function _doInit(swiperObj) {
    const swiperElem = typeof swiperObj.el === 'object' ? swiperObj.el : document.querySelector(swiperObj.el)
    const imgWrapper = swiperElem.querySelector('.hiw-block-image') || null
    if (imgWrapper) {
      const h = imgWrapper.getBoundingClientRect().height
      swiperElem.style.setProperty('--block-height', `${h}px`)
    }
  }

  function _doCarousel(block) {
    const blockId = block.dataset.blockId

    const option = {
      init: false,
      spaceBetween: 10,
      slidesPerView: 1.1,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      navigation: {
        nextEl: '.carousel--icon-next',
        prevEl: '.carousel--icon-previous',
      },
      pagination: {
        el: block.querySelector('.swiper-pagination'),
        type: 'progressbar'
      },
      breakpoints: {
        990: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
        }
      }
    }

    const swiperObj = new Swiper(`.js-hiw-block-carousel-${blockId}`, option)
    swiperObj.on('init', _doInit(swiperObj))
    swiperObj.on('resize', (swiper) => {
      _doInit(swiper)
      const sectionId = block.dataset.sectionId
      document.querySelector(`.hiw-${sectionId}`).style.setProperty('--image-container-min-height', 'auto')
      _doAdjustMinHeight(block)
    })
    swiperObj.on('afterInit', (swiper) => _doAdjustMinHeight(block))
    swiperObj.init()
  }

  function buildHIWBlockCarousel() {
    const $blocks = document.querySelectorAll('.js-hiw-block-wrapper')
    for (const $block of $blocks) {
      const blockId = $block.dataset.blockId
      const carouselElem = $block.querySelector(`.js-hiw-block-carousel-${blockId}[is-carousel]`)
      if (carouselElem) {
        _doCarousel($block)
      } else {
        _doAdjustMinHeight($block)
      }
    }
  }

  buildHIWBlockCarousel()

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', buildHIWBlockCarousel)
  }
})
